import type { IntegrationModule } from './integrationModules';

export const INTEGRATION_MODULES_EN: IntegrationModule[] = [
  {
    id: 'vms',
    icon: 'vms',
    title: 'Existing VMS / NVR',
    plain: 'Leave cameras and recorders in place. Send alerts only for moments that match policy.',
    docsPath: '/docs/vms-iot-integration',
    docHint: 'INTEGRATION_VMS_IOT_EDGE.md',
  },
  {
    id: 'webhook',
    icon: 'webhook',
    title: 'SOC / tickets',
    plain: 'Deliver fields a SOC or helpdesk can ingest without rewriting the workflow.',
    docsPath: '/docs/vms-iot-integration',
  },
  {
    id: 'mqtt',
    icon: 'mqtt',
    title: 'Sensors / gates',
    plain: 'Bind door and sensor signals to the same rules as video alerts.',
    docsPath: '/docs/vms-iot-integration',
    docHint: 'FUSION_INTEL_BUS_TOPICS.md',
  },
  {
    id: 'fusion',
    icon: 'fusion',
    title: 'All sources',
    plain: 'Collect camera, radar, and external alerts into one shape.',
    docsPath: '/docs/edge-and-cloud',
    docHint: 'FUSION_CONNECTORS_INGEST_CONTRACT.md',
  },
  {
    id: 'edge',
    icon: 'edge',
    title: 'On-site gear',
    plain: 'Judge on site first. Send a short alert upward only when needed.',
    docsPath: '/docs/edge-and-cloud',
    docHint: 'LAYERED_TICK_METRICS.md',
  },
  {
    id: 'openapi',
    icon: 'openapi',
    title: 'Partner / SI',
    plain: 'OpenAPI and examples so SI and other products can attach.',
    docsPath: '/docs/api-and-sdk',
    docHint: 'openapi_console.json',
  },
];
